var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommonExpansionPanel',{scopedSlots:_vm._u([{key:"title-panel",fn:function(){return [_vm._v(" Información personal ")]},proxy:true}])},[_c('v-expansion-panel-content',[(_vm.switch_data == 1)?_c('view-data',{attrs:{"personalData":_vm.personalData},on:{"showModal":function($event){return _vm.$emit('showModal')}}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }